import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyerPurchaseHistoryModal from '../../../../views/app/common/modal/BuyerPurchaseHistoryModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class BuyerPurchaseHistoryModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { appToggleModal } = this.props;
    appToggleModal({
      name: 'buyerPurchaseHistoryModal',
    });
  };

  render() {
    const { isOpen, data } = this.props;

    return <BuyerPurchaseHistoryModal isOpen={isOpen} data={data} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.buyerPurchaseHistoryModal.isOpen,
    data: state.app.buyerPurchaseHistoryModal.data,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(BuyerPurchaseHistoryModalContainer));
